import { connect } from 'react-redux';
import ContactUsPage from 'pages/ContactUsPageNew';
import newOlsActions from 'store/newOls/actions';
import contactUsActions from 'store/contactUs/actions';

const mapStateToProps = state => {
  return {
    dropdownDetails: state.contactUs.dropdownDetails,
    isSubmitContactLoading: state.contactUs.isSubmitContactLoading,
    contactUsDetails: state.contactUs.contactUsDetails,
  };
};
const mapDispatchToProps = {
  loadDropdownData: contactUsActions.Creators.loadDropdownDataRequest,
  submitContact: contactUsActions.Creators.submitContactRequest,
};
export default connect(mapStateToProps, mapDispatchToProps)(ContactUsPage);
